/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '~/common/types/graphql.ts';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type BatchChangeRequestsJobSubmitInput = {
  dryRun?: boolean | null | undefined;
  dryRunOptions?: DryRunOptions | null | undefined;
  jobId: string;
  logLevel?: string | null | undefined;
  tenantId: string;
};

export type DryRunOptions = {
  limit?: number | null | undefined;
  offset?: number | null | undefined;
};

export type SubmitBatchChangeRequestsJobMutationVariables = Exact<{
  input: Types.BatchChangeRequestsJobSubmitInput;
}>;


export type SubmitBatchChangeRequestsJobMutation = { cnutSubmitBatchChangeRequestsJob:
    | { __typename: 'BatchChangeRequestsJobSubmitOutput', jobId: string, jobRunId: string }
    | { __typename: 'ClientError', code: string, message: string }
   };


export const SubmitBatchChangeRequestsJobDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SubmitBatchChangeRequestsJob"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BatchChangeRequestsJobSubmitInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cnutSubmitBatchChangeRequestsJob"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BatchChangeRequestsJobSubmitOutput"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobId"}},{"kind":"Field","name":{"kind":"Name","value":"jobRunId"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ClientError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<SubmitBatchChangeRequestsJobMutation, SubmitBatchChangeRequestsJobMutationVariables>;